<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label>  
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                   <label for="select-status">Status</label>  

                <multiselect id="selecaostatus" v-model="value_status"  required
                :options="statuss" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :preserve-search="true" placeholder="Status" label="descricao" track-by="descricao" name="descricao"
                :preselect-first="false">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadRfiLancamentos()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>

              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-1 @click="reset()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="rfilancamentos"  small hover striped sticky-header="550px"  :items="rfilancamentos" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaRfi(data.item)"    title="Acessar RFI"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar"  ok-title="Gravar" @ok="posttRfi(),reset()"  hide-footer size="xl" title="Carros em manutenção"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-carro" type="hidden" v-model="rfilancamento.id_carro" />
              
              <b-col cols="3">
                <label for="input-live">Carro</label>
                <b-form-input id="carro" v-model="value_carro" required @click="reset()" @keyup.enter="loadCarros()" placeholder="Digite o Nº do carro"></b-form-input>                                              
              </b-col>

              <b-col cols="5">
                <label class="ml-4" for="input-live">Modelo Chassi</label> 
                <b-form-input class="ml-3" id="carro-chassi" v-model="rfilancamento.chassi" readonly placeholder=""></b-form-input>
              </b-col>

              <b-col cols="3">
                <label for="input-live">Placa</label>
                <b-form-input id="placa" v-model="rfilancamento.placa" readonly placeholder=""></b-form-input>              
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <label for="input-live">Motivo</label>
                <b-form-input v-model="rfilancamento.motivo" required placeholder="Digite o motivo"></b-form-input>              
              </b-col>
            </b-row>  

            <b-row>

            <b-col cols="10">
              <label for="input-setor">Setor</label> 
              <div>                
                <b-form-select                  
                  v-model="rfilancamento.id_status"  
                  required                                                   
                  :options="statuss"
                  class="mb-3 "
                  text-field="descricao"                            
                >
                
                </b-form-select>
              </div>
            </b-col>  

              
                <b-col cols="2">                                              
                  <b-form-checkbox
                    id="lavador" 
                    class="mb-3 mt-5"
                    v-model="rfilancamento.lavador"                  
                    name="checkbox-1"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Lavador <!-- --{{rfilancamento.lavador}} -->
                  </b-form-checkbox>                
                </b-col>
              
            </b-row> 

            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Peças</label> 
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="rfilancamento.material"                  
                  size="sm"
                  placeholder="Digite códigos dos materias"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Observações:</label>
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="rfilancamento.observacao"
                  size="sm"      
                  placeholder="Digite as observações"
                ></b-form-textarea>
              </b-col>
            </b-row> 

             <b-button class="mt-3" variant="success" block @click="posttRfi()">Gravar</b-button>
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

  
  



</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'ManutencaoRfiLancamento',    

    data: function() {

        
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,            
            garagem:{}, 
            garagens: [],   // [] lista            
            value_garagem:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            
                                     
            rfilancamento:{},// [] lista   
            rfilancamentos:[],// [] lista
            carro:{},
            selected: null,
            
            value_carro:'',
            value_motivo: '',
            value_pecas:'',
            value_observacoes:'',
            value_status:'',

            //value_carro:'',   

            
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [
                { key: 'id', label: 'Nº', sortable: true },     
                { key: 'id_filial', label: 'Garagem', sortable: true },                 
                { key: 'carro', label: 'Carro', sortable: true },                
                
                { key: 'dt_inclusao', label: 'Entrada', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_inclusao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                
                { key: 'motivo', label: 'Motivo', sortable: true },
                { key: 'status', label: 'Status', sortable: true },                

                


                { key: 'dt_liberacao', label: 'Ultima atualização', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_liberacao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                //{ key: 'tempo', label: 'Tempo Gasto', sortable: true, formatter: (value, key, rfilancamentos) => {                                        return moment(rfilancamentos.dias).format('MMM:DD:HH:mm').replace('Data inválida','-') ; }  },
                { key: 'tempo', label: ' Tempo Gasto', sortable: true },
                { key: 'material', label: ' Material', sortable: true },

                { key: 'observacao', label: 'Observações', sortable: true },                
                { key: 'lavador', label: 'Lavador', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                

               // { key: 'cadastrado_por', label: 'Cadastrado por', sortable: true },
               // { key: 'liberado_por', label: 'Liberado por', sortable: true },
                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      //barra de progresso
      ready () {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          //this.loadRfiLancamentos()
        }
      },1000)
      },

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

    

        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },        

        loadStatus() {
          const url = `${baseApiUrl}/manutencao/rfi/status`
          axios.get(url).then(res => {
            this.statuss = res.data.map(status => {              
               return { ... status, value: status.gdm_carro_manutencao_status_id, descricao: status.descricao }
            })
          })
        },

        loadStatusInc() {
          const url = `${baseApiUrl}/manutencao/rfi/status`
          axios.get(url).then(res => {
            this.status = res.data.map(status => {              
              return { ... this.status, value: status.gdm_carro_manutencao_status_id, descricao: status.descricao }
              //return { ...category, value: category.id, text: category.path }
            })
          })
        },

        
        loadCarros() {          
          const url = `${baseApiUrl}/despachante/carro/${this.value_carro}`
          axios.get(url).then(res => { this.rfilancamento = res.data })          
        },        

        loadRfiLancamentos() {                        
            let corpo = {    
                "id_filial": `${[this.value_garagem.map(a => a.id_filial)]}`,                
                "id_status": `${[this.value_status.map(r => r.gdm_carro_manutencao_status_id)]}`                
            };
 
            const url = `${baseApiUrl}/manutencao/rfi/lancamentos`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.rfilancamentos = res.data.map(rfilancamento => {
                            return {                              
                              id: rfilancamento.id, 
                              id_filial: rfilancamento.id_filial, 
                              id_carro: rfilancamento.id_carro,
                              carro: rfilancamento.carro,
                              data_servico: rfilancamento.data_servico, 
                              id_status: rfilancamento.id_status,
                              status: rfilancamento.status,
                              motivo: rfilancamento.motivo,
                              dt_inclusao: rfilancamento.dt_inclusao,
                              dt_liberacao: rfilancamento.dt_liberacao, 
                              material: rfilancamento.material,
                              tempo: rfilancamento.tempo,
                              observacao: rfilancamento.observacao, 
                              cadastrado_por: rfilancamento.cadastrado_por, 
                              liberado_por: rfilancamento.liberado_por, 
                              lavador: rfilancamento.lavador, 
                              
                            }              
                                                })
                        })            
        }, 
        
        loadCarregaRfi(rfilancamento){
            this.rfilancamento = { ...rfilancamento }
        },


        loadStatusmap(statuss){
            this.statuss = { ...statuss }
        },


        

        
        
        posttRfi() {                        
        let corpo = { 
                "gdm_carro_manutencao_id": `${this.rfilancamento.id}`,
                "id_carro": `${this.rfilancamento.id_carro}`,
                "motivo": `${this.rfilancamento.motivo}`,
                "gdm_carro_manutencao_status_id": `${this.rfilancamento.id_status}`,  
                "gdm_carro_manutencao_status_id_up": `${this.rfilancamento.id_status}`,  
                //"gdm_carro_manutencao_status_id": `${this.value_statusinc.map(aa => aa.gdm_carro_manutencao_status_id)}`,                                                                  
                //"gdm_carro_manutencao_status_id_up": `${this.value_statusinc.map(aa => aa.gdm_carro_manutencao_status_id)}`,
                "material": `${this.rfilancamento.material}`,
                "observacao": `${this.rfilancamento.observacao}`,               
                "lavador": `${this.rfilancamento.lavador}`
        };

        const url = `${baseApiUrl}/manutencao/rfi/lancamentos/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {            
            this.rfilancamento = {}
            this.loadRfiLancamentos()
            this.value_carro = ''            
        }
       
    },



    mounted() {        
        this.loadGaragens()  
        this.loadStatus()              
        this.loadRfiLancamentos()
        this.loadCarregaRfi()
        this.loadCarros()
        this.loadStatusInc()
        this.loadStatusmap()        
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>